import createContext from '@ant-design/create-react-context';
var RowContext = createContext({});
export default RowContext;
//# sourceMappingURL=RowContext.js.map



//////////////////
// WEBPACK FOOTER
// ./~/antd/es/grid/RowContext.js
// module id = 325
// module chunks = 3